import { useNavigate } from "react-router-dom";
import { ShoppingCart, Heart, Package, Store } from "lucide-react";

export default function ShopNav({ token, cartCount = 0, active }) {
  const navigate = useNavigate();
  const go = (path) => navigate(`${path}?token=${token}`);
  const Item = ({ id, icon, label, path, badge }) => (
    <button data-testid={`shopnav-${id}`} onClick={() => go(path)} className={`relative inline-flex items-center gap-1 px-3 py-2 border-2 themed-border font-black uppercase text-xs ${active === id ? "themed-shadow-accent" : ""}`} style={{ background: active === id ? "var(--bq-accent)" : "var(--bq-card-bg)" }}>
      {icon} <span className="hidden sm:inline">{label}</span>
      {badge > 0 && <span className="absolute -top-2 -right-2 w-5 h-5 text-[10px] flex items-center justify-center border-2 border-black rounded-full" style={{ background: "var(--bq-danger)", color: "#fff" }}>{badge}</span>}
    </button>
  );
  return (
    <header className="sticky top-0 z-40 border-b-4 themed-border px-4 md:px-6 py-3 flex items-center justify-between" style={{ background: "var(--bq-card-bg)" }}>
      <div className="flex items-center gap-2 font-black uppercase text-lg cursor-pointer" onClick={() => go("/shop")}><Store size={22} /> Merch Store</div>
      <div className="flex items-center gap-2">
        <Item id="shop" icon={<Store size={16} />} label="Shop" path="/shop" />
        <Item id="wishlist" icon={<Heart size={16} />} label="Wishlist" path="/shop/wishlist" />
        <Item id="orders" icon={<Package size={16} />} label="Orders" path="/shop/orders" />
        <Item id="cart" icon={<ShoppingCart size={16} />} label="Cart" path="/shop/cart" badge={cartCount} />
      </div>
    </header>
  );
}
